
















import { EmailChannelDetails } from '@/types';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component
export default class EmailIntegration extends Vue {
  @Prop() private integrationDetails!: EmailChannelDetails;
  @Getter private hasPermission!: any;

  private readonly rules: any = {
    required: (value: string) => !!value || 'Email is required.',
    email: (value: string) => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || 'Invalid e-mail.';
    },
  };

  private handleErrorChange(value: boolean) {
    this.$emit('validate', !value);
  }
}
